'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var debug = require('debug');

var log = Object.assign(debug('libp2p:relay'), {
  error: debug('libp2p:relay:err')
});

var _require = require('set-delayed-interval'),
    setDelayedInterval = _require.setDelayedInterval,
    clearDelayedInterval = _require.clearDelayedInterval;

var AutoRelay = require('./auto-relay');

var _require2 = require('./utils'),
    namespaceToCid = _require2.namespaceToCid;

var _require3 = require('./constants'),
    RELAY_RENDEZVOUS_NS = _require3.RELAY_RENDEZVOUS_NS;
/**
 * @typedef {import('../')} Libp2p
 *
 * @typedef {Object} RelayAdvertiseOptions
 * @property {number} [bootDelay = ADVERTISE_BOOT_DELAY]
 * @property {boolean} [enabled = true]
 * @property {number} [ttl = ADVERTISE_TTL]
 *
 * @typedef {Object} HopOptions
 * @property {boolean} [enabled = false]
 * @property {boolean} [active = false]
 *
 * @typedef {Object} AutoRelayOptions
 * @property {number} [maxListeners = 2] - maximum number of relays to listen.
 * @property {boolean} [enabled = false]
 */


var Relay = /*#__PURE__*/function () {
  /**
   * Creates an instance of Relay.
   *
   * @class
   * @param {Libp2p} libp2p
   */
  function Relay(libp2p) {
    _classCallCheck(this, Relay);

    this._libp2p = libp2p;
    this._options = _objectSpread({}, libp2p._config.relay); // Create autoRelay if enabled

    this._autoRelay = this._options.autoRelay.enabled && new AutoRelay(_objectSpread({
      libp2p: libp2p
    }, this._options.autoRelay));
    this._advertiseService = this._advertiseService.bind(this);
  }
  /**
   * Start Relay service.
   *
   * @returns {void}
   */


  _createClass(Relay, [{
    key: "start",
    value: function start() {
      // Advertise service if HOP enabled
      var canHop = this._options.hop.enabled;

      if (canHop && this._options.advertise.enabled) {
        this._timeout = setDelayedInterval(this._advertiseService, this._options.advertise.ttl, this._options.advertise.bootDelay);
      }
    }
    /**
     * Stop Relay service.
     *
     * @returns {void}
     */

  }, {
    key: "stop",
    value: function stop() {
      clearDelayedInterval(this._timeout);
    }
    /**
     * Advertise hop relay service in the network.
     *
     * @returns {Promise<void>}
     */

  }, {
    key: "_advertiseService",
    value: function () {
      var _advertiseService2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cid;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return namespaceToCid(RELAY_RENDEZVOUS_NS);

              case 3:
                cid = _context.sent;
                _context.next = 6;
                return this._libp2p.contentRouting.provide(cid);

              case 6:
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                if (_context.t0.code === 'NO_ROUTERS_AVAILABLE') {
                  log.error('a content router, such as a DHT, must be provided in order to advertise the relay service', _context.t0); // Stop the advertise

                  this.stop();
                } else {
                  log.error(_context.t0);
                }

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function _advertiseService() {
        return _advertiseService2.apply(this, arguments);
      }

      return _advertiseService;
    }()
  }]);

  return Relay;
}();

module.exports = Relay;